export default "__VITE_ASSET__DKYJLyBh__"